import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import PrivacyPolicyContent from "./PrivacyPolicyContent";
import "./privacy-policy-drawer.css";

type PrivacyPolicyDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const PrivacyPolicyDrawer = ({ isOpen, onClose }: PrivacyPolicyDrawerProps) => {
  const panelRef = useRef<HTMLElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!isOpen) return;

    const html = document.documentElement;
    html.classList.add("tec-privacy-drawer-open");

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    window.addEventListener("keydown", handleKeyDown);
    closeButtonRef.current?.focus();

    return () => {
      html.classList.remove("tec-privacy-drawer-open");
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <>
      <button
        type="button"
        className={`privacy-drawer__backdrop${isOpen ? " privacy-drawer__backdrop--visible" : ""}`}
        aria-label="Cerrar política de privacidad"
        onClick={onClose}
        tabIndex={isOpen ? 0 : -1}
      />
      <aside
        ref={panelRef}
        className={`privacy-drawer__panel${isOpen ? " privacy-drawer__panel--open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="privacy-drawer-title"
        aria-hidden={!isOpen}
      >
        <header className="privacy-drawer__header">
          <h1 id="privacy-drawer-title" className="privacy-drawer__title">
            Política de privacidad
          </h1>
          <button
            ref={closeButtonRef}
            type="button"
            className="privacy-drawer__close"
            aria-label="Cerrar"
            onClick={onClose}
          >
            <i className="ri-close-line" aria-hidden />
          </button>
        </header>
        <div className="privacy-drawer__body">
          <PrivacyPolicyContent />
        </div>
      </aside>
    </>,
    document.body,
  );
};

export default PrivacyPolicyDrawer;
